export const digitalNoticeboardScreenConstants = {
  BASE_PATH: '/v1/digital_noticeboard_screens',
};
